/** Created by azhou on 2019/3/25.*/
<template>
    <div>
      <div class="d-start-start mt-3">
        <left-text leftText="业务对接人"/>{{StoreBasicInfo.person_liable_name || '无'}}
      </div>
      <!--未认证情况下现实门店注册信息的提交情况-->
      <div v-if="StoreBasicInfo.verify==0">
        <div class="check-item" v-for="(checkItem,index) in checkList" :key="index">
          <span>{{checkItem.name}}</span>
          <i class="iconfont" :class="[checkItem.checked ? 'text-success':'text-danger']"
             v-html="checkItem.checked?successIcon:failIcon"></i>
        </div>
      </div>
      <!--已认证时显示提交的认证材料-->
      <div v-if="StoreBasicInfo.verify==0">
        <div class="d-start-start mt-3">
          <left-text leftText="营业执照"/>
          <!-- <img class="rounded cursor-pointer" v-lazy="ImgPreUrl + StoreBasicInfo.certpic"
                 width="100" height="100" @click="imgPreview" /> -->
          <div class="demo-image__preview">
            <el-image 
              style="width: 100px; height: 100px"
              :src="ImgPreUrl+StoreBasicInfo.certpic" 
              :preview-src-list="srcList">
            </el-image>
          </div>
        </div>
      </div>
      <!--待审核时显示认证类型和认证材料-->
      <div v-if="StoreBasicInfo.verify==1">
        <div class="d-start-start">
          <div class="w-50">
            <div class="d-center-start mt-3">
              <left-text leftText="认证类型"/>{{StoreBasicInfo.edit_status==1 ? '重新认证' : '新用户认证'}}
            </div>
            <div class="d-start-start mt-3">
              <left-text leftText="营业执照"/>
              <div class="demo-image__preview">
                <el-image 
                  style="width: 100px; height: 100px"
                  :src="ImgPreUrl+StoreBasicInfo.certpic|| StoreBasicInfo.avatar" 
                  :preview-src-list="srcList">
                </el-image>
              </div>
              <!-- <img class="rounded cursor-pointer" v-lazy="ImgPreUrl + StoreBasicInfo.certpic"
                 width="100" height="100" @click="imgPreview" /> -->
            </div>
            <div class="d-start-start mt-3" >
              <left-text leftText="消防验收合格证"/>
              <span v-if="!StoreBasicInfo.certfire">未上传</span>
              <div class="demo-image__preview" v-else>
                <el-image 
                  style="width: 100px; height: 100px"
                  :src="ImgPreUrl+StoreBasicInfo.certfire" 
                  :preview-src-list="verifyList">
                </el-image>
              </div>
            </div>
            <div class="d-start-start mt-3" >
              <left-text leftText="卫生许可证"/>
              <span v-if="!StoreBasicInfo.certheal">未上传</span>
              <div class="demo-image__preview" v-else>
                <el-image 
                  style="width: 100px; height: 100px"
                  :src="ImgPreUrl+StoreBasicInfo.certheal" 
                  :preview-src-list="verifyList">
                </el-image>
              </div>
            </div>
            <div class="d-start-start mt-3" >
              <left-text leftText="特种行业许可证"/>
              <span v-if="!StoreBasicInfo.certspec">未上传</span>
              <div class="demo-image__preview" v-else>
                <el-image 
                  style="width: 100px; height: 100px"
                  :src="ImgPreUrl+StoreBasicInfo.certspec" 
                  :preview-src-list="verifyList">
                </el-image>
              </div>
            </div>
            <div class="d-start-start mt-3">
              <left-text leftText="省市区"/>
              {{StoreBasicInfo.province_name}}{{StoreBasicInfo.city_name}}{{StoreBasicInfo.district_name}}{{StoreBasicInfo.address}}
              <i class="el-icon-location location" @click="mapclock(StoreBasicInfo)" v-if="storeInfo.type==3" ></i>
            </div>
          </div>
          <!--重新认证时显示认证材料-->
          <div class="w-50 infos" v-show="StoreBasicInfo.edit_status==1">
            <div class="information mr-3">新认证信息</div>
            <div>
              <div class="d-center-start mt-3" v-if="StoreBasicInfo.edit_verify.title">
                <left-text leftText="名称"/>{{StoreBasicInfo.edit_verify.title}}
              </div>
              <div class="d-center-start mt-3"><left-text leftText="认证理由"/>{{StoreBasicInfo.edit_verify.reason}}</div>
              <div class="d-start-start mt-3" v-if="StoreBasicInfo.certpic">
                <left-text leftText="营业执照"/>
                <div class="demo-image__preview">
                  <el-image 
                    style="width: 100px; height: 100px"
                    :src="ImgPreUrl+StoreBasicInfo.edit_verify.certpic" 
                    :preview-src-list="verifyList">
                  </el-image>
                </div>
              </div>
              <div class="d-start-start mt-3" >
                <left-text leftText="消防验收合格证"/>
                <span v-if="!StoreBasicInfo.edit_verify.certfire">未上传</span>
                <div class="demo-image__preview" v-else>
                  <el-image 
                    style="width: 100px; height: 120px"
                    :src="ImgPreUrl+StoreBasicInfo.edit_verify.certfire" 
                    :preview-src-list="verifyList">
                  </el-image>
                </div>
              </div>
              <div class="d-start-start mt-3" >
                <left-text leftText="卫生许可证"/>
                <span v-if="!StoreBasicInfo.edit_verify.certheal">未上传</span>
                <div class="demo-image__preview" v-else>
                  <el-image 
                    style="width: 100px; height: 10px"
                    :src="ImgPreUrl+StoreBasicInfo.edit_verify.certheal" 
                    :preview-src-list="verifyList">
                  </el-image>
                </div>
              </div>
              <div class="d-start-start mt-3" >
                <left-text leftText="特种行业许可证"/>
                <span v-if="!StoreBasicInfo.edit_verify.certspec">未上传</span>
                <div class="demo-image__preview" v-else>
                  <el-image 
                    style="width: 100px; height: 120px"
                    :src="ImgPreUrl+StoreBasicInfo.edit_verify.certspec" 
                    :preview-src-list="verifyList">
                  </el-image>
                </div>
              </div>
              <div class="d-start-start mt-3">
                <left-text leftText="省市区"/>
                {{StoreBasicInfo.edit_verify.province_name}}{{StoreBasicInfo.edit_verify.city_name}}{{StoreBasicInfo.edit_verify.district_name}}{{StoreBasicInfo.edit_verify.address}}
                <i class="el-icon-location location" v-if="storeInfo.type==3&&StoreBasicInfo.edit_verify.longitude" @click="mapclock(StoreBasicInfo.edit_verify)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--周边交通-->
      <surrounding-traffic id="tabMapInfo" :DisplayBasicInfo='DisplayBasicInfo' v-if="map"/>
    </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
    import SurroundingTraffic from './SurroundingTraffic'
  export default {
    name: 'VerifyInfo',
    components:{SurroundingTraffic},
    computed: {
      ...mapGetters(['storeInfo']),
      ...mapState(['StoreBasicInfo']),
      checkList () {
        let pic = this.StoreBasicInfo.pic ? this.StoreBasicInfo.pic.length : ''
        let interiorPic = this.StoreBasicInfo.pic_lobby ? this.StoreBasicInfo.pic_lobby.length : ''
        let storeCn = this.$options.filters['formatVar'](this.storeInfo.type, 'StoreType')
        let commonArr = [
          { name: storeCn + '名称', checked: Boolean(this.StoreBasicInfo.title) },
          { name: storeCn + '地址', checked: Boolean(this.StoreBasicInfo.address) },
          { name: '办公电话', checked: Boolean(this.StoreBasicInfo.tel || this.StoreBasicInfo.travel_tel) },
          { name: '营业执照', checked: Boolean(this.StoreBasicInfo.certpic) },
        ]
        if (this.storeInfo.type === 6) {
          return [
            ...commonArr,
            { name: '传真号码', checked: Boolean(this.StoreBasicInfo.viewpoint_fax) },
            { name: '景区主题', checked: Boolean(this.StoreBasicInfo.theme) },
            { name: '景区星级', checked: Boolean(this.StoreBasicInfo.star) },
            { name: storeCn + '外观图', checked: Boolean(pic) }
          ]
        }
        if (this.storeInfo.type === 3 || this.storeInfo.type === 5) {
          return [
            ...commonArr,
            {
              name: this.storeInfo.type === 3 ? '酒店总机' : '前台电话',
              checked: Boolean(this.StoreBasicInfo.hotel_tel || this.StoreBasicInfo.homestay_tel)
            },
            { name: storeCn + '外观图', checked: Boolean(pic) },
            { name: storeCn + '内景图', checked: Boolean(interiorPic) },
            { name: storeCn + '房间', checked: Boolean(this.StoreBasicInfo.room_list?this.StoreBasicInfo.room_list.length:0) },

          ]
        } else {
          return commonArr
        }
      },
      allChecked () {
        let result = true
        for (let i = 0; i < this.checkList.length; i++) {
          if (!this.checkList[i].checked) {
            result = false
            return false
          }
        }
        return result
      },
    },
    watch: {
      StoreBasicInfo () {
        let item = this.ImgPreUrl + this.StoreBasicInfo.certpic;
        let src= this.ImgPreUrl+this.StoreBasicInfo.edit_verify.certpic
        this.srcList.push(item);
        this.verifyList.push(src);
      }
    },
    data () {
      return {
        successIcon: '&#xe74a;',
        failIcon: '&#xe7b7;',
        srcList: [],
        verifyList:[],
        DisplayBasicInfo:{
          longitude:'',
          latitude:''
        },
        map:false,
      }
    },
    methods: {
       mapclock(e){
        this.map=!this.map;
        this.DisplayBasicInfo=e;
      },
      imgPreview () {
        this._CarouselView({
          currentImg: 0,
          picArray: [this.StoreBasicInfo.certpic]
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .check-item {
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 10px;
  }
  .location{
    font-size: 20px;
    color: var(--smtc-color-primary); 
    margin-left: 6px;
    cursor: pointer;
  }
  .location:hover{
    color: #0fa4bb;
  }
  .information{
    width: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    border-left: 1px #eee solid;
    padding: 0 12px;
  }
  .infos{
    display: flex;
    overflow: hidden;
    position: relative;
  }
</style>
